import React, { useEffect, useRef, useState } from 'react';

interface MultiSelectDropdownProps {
  label: string;
  options: string[];
  selected: string[];
  onChange: (values: string[]) => void;
}

export default function MultiSelectDropdown({
  label,
  options,
  selected,
  onChange,
}: MultiSelectDropdownProps) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleValue = (value: string) => {
    if (selected.includes(value)) {
      onChange(selected.filter((v) => v !== value));
    } else {
      onChange([...selected, value]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <label className="block text-xs font-semibold mb-1">{label}</label>

      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-48 px-3 py-2 text-sm rounded-md border
                           bg-white dark:bg-gray-800
                           border-gray-300 dark:border-gray-600
                           text-left
                           focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {selected.length === 0
          ? 'All'
          : selected
              .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
              .join(', ')}
      </button>

      {open && (
        <div
          className="absolute z-10 mt-1 w-full rounded-md shadow-lg
                               bg-white dark:bg-gray-800
                               border border-gray-200 dark:border-gray-700"
        >
          {options.map((option) => (
            <label
              key={option}
              className="flex items-center gap-2 px-3 py-2 text-sm cursor-pointer
                                       hover:bg-gray-100 dark:hover:bg-gray-700"
            >
              <input
                type="checkbox"
                checked={selected.includes(option)}
                onChange={() => toggleValue(option)}
                className="cursor-pointer accent-blue-500"
              />
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
